/**
 * CookiePolicyPage — Cookie Policy
 */
import StaticPageLayout from './StaticPageLayout';

export default function CookiePolicyPage() {
  return (
    <StaticPageLayout title={<>Cookie <em style={{ fontStyle: 'italic', color: 'var(--brand)' }}>policy</em>.</>}>
      <p style={{ fontStyle: 'italic' }}>Last updated: May 2026</p>

      <p>This Cookie Policy explains how Connekted.in, operated by Bite Binary, uses cookies and similar tracking technologies when you visit our website and use our platform.</p>

      <h3>1. What are cookies?</h3>
      <p>Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences, understand how you interact with the site, and improve your experience. Cookies may be "session" cookies (deleted when you close your browser) or "persistent" cookies (remain until they expire or you delete them).</p>

      <h3>2. Essential cookies</h3>
      <p>These cookies are strictly necessary for the platform to function. They include session cookies that keep you logged in, security tokens that protect against cross-site request forgery, and preference cookies that remember your settings (such as cookie consent choices). Essential cookies cannot be disabled as the service would not function without them.</p>

      <h3>3. Analytics cookies</h3>
      <p>With your consent, we use analytics cookies to understand how visitors interact with the platform. These cookies help us measure page views, feature usage, session duration, and navigation patterns. Analytics data is aggregated and anonymised. We do not use analytics cookies to personally identify you. We do not use Google Analytics or any third-party analytics service that shares data with advertising networks.</p>

      <h3>4. Marketing cookies</h3>
      <p>With your consent, we may use marketing cookies to measure the effectiveness of our own marketing campaigns. We do not serve third-party advertisements on Connekted.in. Marketing cookies, if enabled, are used solely to understand which of our own campaigns led you to the platform.</p>

      <h3>5. Your choices</h3>
      <p>When you first visit Connekted.in, you will see a cookie consent banner. You can accept all cookies, reject optional cookies (allowing essential cookies only), or customise your preferences. You can change your cookie preferences at any time by clearing your browser cookies and revisiting the site, which will trigger the consent banner again.</p>

      <h3>6. Browser settings</h3>
      <p>Most browsers allow you to control cookies through their settings. You can typically set your browser to refuse all cookies, accept only first-party cookies, or delete cookies when you close your browser. Note that disabling essential cookies may prevent the platform from functioning correctly.</p>

      <h3>7. Local storage</h3>
      <p>In addition to cookies, we use browser local storage to persist your session state and preferences. Local storage functions similarly to cookies but is not sent with HTTP requests. The same consent principles apply.</p>

      <h3>8. Changes</h3>
      <p>We may update this Cookie Policy from time to time. If we make material changes to how we use cookies, we will re-prompt you for consent.</p>

      <h3>Contact</h3>
      <p>For questions about our use of cookies, email hello@connektedin.com.</p>
    </StaticPageLayout>
  );
}
